export enum EmailChannelSettingFormFields {
  Id = 'id',
  SupportEmail = 'supportEmail',
  MembershipEmail = 'membershipEmail',
  SupportEmailSignature = 'supportEmailSignature',
  MembershipEmailSignature = 'membershipEmailSignature',
  InternalEmail = 'internalEmail',
}

export type EmailFormModel = {
  [EmailChannelSettingFormFields.Id]: string;
  [EmailChannelSettingFormFields.SupportEmail]?: string;
  [EmailChannelSettingFormFields.MembershipEmail]?: string;
  [EmailChannelSettingFormFields.SupportEmailSignature]?: string;
  [EmailChannelSettingFormFields.MembershipEmailSignature]?: string;
  [EmailChannelSettingFormFields.InternalEmail]?: string;
};

export enum VoiceChannelSettingFormFields {
  Id = 'id',
  PhoneSupport = 'fwdPhoneSupport',
  PhoneSignature = 'fwdPhoneSignature',
  PhoneTwilio = 'fwdPhoneTwilio',
  CallerIdPhone = 'callerIdPhone',
  PhoneReroute = 'fwdPhoneReroute',
  PhonePublished = 'fwdPhonePublished',
  PhonePublishedExt = 'fwdPhonePublishedExt',
}

export type VoiceFormModel = {
  [VoiceChannelSettingFormFields.Id]: string;
  [VoiceChannelSettingFormFields.PhoneSupport]?: string;
  [VoiceChannelSettingFormFields.PhoneSignature]?: string;
  [VoiceChannelSettingFormFields.PhoneTwilio]?: string;
  [VoiceChannelSettingFormFields.CallerIdPhone]?: string;
  [VoiceChannelSettingFormFields.PhoneReroute]?: string;
  [VoiceChannelSettingFormFields.PhonePublished]?: string;
  [VoiceChannelSettingFormFields.PhonePublishedExt]?: string;
};
